import { render, staticRenderFns } from "./ProductCardCartVersionComponent.vue?vue&type=template&id=1b3dfd74"
import script from "./ProductCardCartVersionComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardCartVersionComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductCardCartVersionComponent.vue?vue&type=style&index=0&id=1b3dfd74&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports